import { BasicFilters } from "../../basic-filters";
import { Campaign } from "../../Campaigns/campaign";
import { DDL } from "../../ddl";
import { BasicAuditReturn } from "./basic-audit-return";

export class AuditResultFilters extends BasicFilters {
    public Campaigns: Campaign[] = [];
    public CampaignAudits: BasicAuditReturn[]=[];
    public IsCampaign: boolean = false;
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
        if (values.hasOwnProperty('Campaings')) {
            this.Campaigns = [];
            ((values as AuditResultFilters)['Campaigns'] as Campaign[]).forEach(element => {
                this.Campaigns.push(new Campaign(element));
            });
        }
    }
}